import { useState } from "react";
import EstadisticasPanel from "@/components/dashboard/EstadisticasPanel";
import ResumenEjecutivo from "@/components/dashboard/ResumenEjecutivo";
import { canEdit, isAdmin, useAuth } from "@/lib/auth";
import AyudaVista from "@/ui/AyudaVista";
import { ayudaEstadisticas } from "@/components/ayuda/vistas/estadisticas";

// Vista propia de Estadísticas (Req 2). Dos secciones: "Panorama" (el
// EstadisticasPanel autónomo, con drill-down a /casos) y "Resumen ejecutivo"
// (Req 5: KPIs por periodo + PDF), este último solo para admin/soporte.
export default function Estadisticas() {
  const me = useAuth((s) => s.user);
  const puedeEjecutivo = canEdit(me);
  const [vista, setVista] = useState<"panorama" | "ejecutivo">("panorama");
  const enEjecutivo = vista === "ejecutivo" && puedeEjecutivo;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <h1 className="text-xl font-semibold">Estadísticas</h1>
        <AyudaVista
          titulo="Estadísticas"
          {...ayudaEstadisticas({ puedeEjecutivo, admin: isAdmin(me) })}
        />
      </div>

      {puedeEjecutivo && (
        <div className="border-b border-ink-700 flex gap-1">
          {(["panorama", "ejecutivo"] as const).map((v) => (
            <button
              key={v}
              onClick={() => setVista(v)}
              className={`px-4 py-2 text-sm border-b-2 -mb-px transition ${
                vista === v
                  ? "border-accent-500 text-accent-400"
                  : "border-transparent text-zinc-400 hover:text-white"
              }`}
            >
              {v === "panorama" ? "Panorama" : "Resumen ejecutivo"}
            </button>
          ))}
        </div>
      )}

      {enEjecutivo ? <ResumenEjecutivo /> : <EstadisticasPanel />}
    </div>
  );
}
